import {validate as uuidValidate} from 'uuid';

export default {
    getBookingSteps: (state, getters) => {
        let bookingStartHidden = !(getters.requireAuthentication)
        let bookingStartDisabled = false
        let bookingStartInvalid = !state.stepsValidationState.bookingStart && !bookingStartHidden

        let calendarDisabled = bookingStartInvalid
        let calendarInvalid = !state.stepsValidationState.calendar

        let generalDisabled = bookingStartInvalid || calendarInvalid || false
        let generalInvalid = !state.stepsValidationState.general

        let bookingsDisabled = generalInvalid || bookingStartInvalid || calendarInvalid || false
        let bookingsInvalid = !state.stepsValidationState.bookings

        let paymentHidden = !getters.hasChargeableBookings
        let paymentDisabled = bookingsInvalid || generalInvalid || bookingStartInvalid || calendarInvalid || false
        let paymentInvalid = !state.stepsValidationState.payment && !paymentHidden

        let summaryDisabled = paymentInvalid || bookingsInvalid || generalInvalid || bookingStartInvalid || calendarInvalid || false

        return [
            {name: "bookingStart", disabled: bookingStartDisabled, hidden: bookingStartHidden},
            {name: "calendar", disabled: calendarDisabled, hidden: false},
            {name: "general", disabled: generalDisabled, hidden: false},
            {name: "bookings", disabled: bookingsDisabled, hidden: false},
            {name: "payment", disabled: paymentDisabled, hidden: paymentHidden},
            {name: "overview", disabled: summaryDisabled, hidden: false}
        ]
    },

    hasChargeableBookings: (state) => {
        const requestedBookingKeys = state.bookingData.requestedBookings
        const bookings = state.bookingData.bookings

        if (!requestedBookingKeys?.length) return false
        const requestBookings = requestedBookingKeys.map(requestedBookingKey => {
                return bookings[requestedBookingKey] ?? null
            }
        ).filter(event => !!event)

        // get all resourceIds of the requested bookings and check if any of them is chargeable
        const resourceIds = requestBookings.map(booking => booking.resourceId)
        const resources = state.siteData.resources
        for (let resourceId of resourceIds) {
            const resource = resources.find(resource => resource.id === resourceId)
            if (resource.chargeable) return true
        }

        return false
    },

    requireAuthentication: (state) => {
        return !!state.siteData?.internal
    },

    getQuestionsForRuleBuilderEvaluator: (state, getter) => (bookingKey) => {
        try {
            let handledAnswers = {...(state.bookingData.answers[bookingKey] ?? {})}
            getter.getSelectQuestionsWithOtherOption(bookingKey)?.forEach(question => {
                if (handledAnswers[question.uuid]?.length) {
                    handledAnswers[question.uuid] = handledAnswers[question.uuid].map(
                        answer => uuidValidate(answer) ? answer : "others"
                    )
                }
            })

            return handledAnswers
        } catch (e) {
            return {}
        }
    },

    getSelectQuestionsWithOtherOption: (state) => (bookingKey) => {
        if (!bookingKey) return []
        let resource = state.siteData.resources?.find(resource => resource.id === state.bookingData.bookings[bookingKey].resourceId)
        if (!resource) return []
        return resource.bookingQuestions?.filter(question => {
            return question.questionType === 1 && !!question.freeTextAllowed && question.options?.length
        })
    },

    getContactPersonDataForRuleBuilderEvaluator: (state) => {
            const prefix = 'contactPerson'
            const person = state.bookingData.booker
            let personData = {}
            personData[prefix + "Salutation"] = person.salutation
            personData[prefix + "Firstname"] = person.firstname
            personData[prefix + "Lastname"] = person.lastname
            personData[prefix + "Birthday"] = person.birthday
            return personData
    },

    getBookingSiteDataForRuleBuilderEvaluator: (state) => {
        return {
            bookingSiteInternal: state.siteData.internal ?? false,
        }
    }
}